// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"464":"1cf36ea5","808":"5dc1b530"}[chunkId] + ".chunk.js";
};